import React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { useQuery } from 'react-query';
import { currentUserInfo } from 'atoms';
import { getMyData } from 'fetchers';
import Header from 'components/Common/Header';
import ModifyItem from 'components/Modify/ModifyItem';
import ModifyItemHasInput from 'components/Modify/ModifyItemHasInput';
import ModifyTitle from 'components/Modify/ModifyTitle';

const Modify = () => {
  const {
    user: { no },
  } = useRecoilValue(currentUserInfo);

  const { isLoading, data } = useQuery(['modify', no], () => getMyData(no), {
    refetchOnMount: true,
  });

  return (
    !isLoading && (
      <>
        <Container>
          <ModifyContainer className='d-flex flex-column'>
            <Header title='내 정보 수정' />
            <ModifySectionContainer className='container-fluid mt-4'>
              <ModifyTitle title='내정보' />
              <ModifyItem title='아이디' description={data.id} />
              <ModifyItem title='이름' description={data.name} />
              <ModifyItem title='닉네임' description={data.nick} />
              <ModifyItem
                title='동 / 호'
                description={`${data.dong}동 ${data.ho}호`}
              />
              <ModifyItemHasInput
                title='이메일'
                description={data.email}
                type='email'
              />
            </ModifySectionContainer>
            <ModifySectionContainer className='container-fluid mt-5'>
              <ModifyTitle title='연락처' />
              <ModifyItemHasInput
                title='핸드폰번호'
                description={data.phone}
                type='cellphone'
              />
            </ModifySectionContainer>
          </ModifyContainer>
        </Container>
      </>
    )
  );
};

const Container = styled.section``;
const ModifyContainer = styled.section``;
const ModifySectionContainer = styled.section``;

export default Modify;
